import apiconfig from "../Configurations/apiConfig.json";
import axios, * as others from "axios";

const baseurl = apiconfig.BaseAPIUrl;
const routes = apiconfig.Routes;
const headerConfig = apiconfig.headerConfig;
const identityServer = apiconfig.identityServer;
const api_health_route = apiconfig.apihealthURI;

export async function RetrieveDropdown(retrieve_dropdown_value) {
  const accessToken = await GetAccessToken();
  var config = {
    headers: {
      Authorization: "Bearer " + accessToken.access_token,
    },
  };

  const dropdown_items = await axios
    .get(process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_VERSION + '/' + routes.populatedropdown + retrieve_dropdown_value, config)
    .then((res) => {
      return res.data?.Data;
    })
    .catch((err) => {
      return { isvalid: false, error: err };
    });
  return dropdown_items;
}

export async function CheckAPIHealth() {
  return await axios
    .get(process.env.REACT_APP_API_BASE_URL + "health", headerConfig)
    .then((res) => {
      console.log("health" + res);
      return res.data?.status === "Healthy" ? { isvalid: true } : {isvalid: false};
    })
    .catch((err) => {
      return { isvalid: false, data: err };
    });
}

export function RetrieveDocuments(searchCriteria) {
  return new Promise((resolve, reject) => {
    GetAccessToken().then((token) => {
      axios
        .post(process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_VERSION + '/' + routes.docsearch, searchCriteria, {
          headers: { Authorization: "Bearer " + token.access_token },
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  });
}

export function GetDocumentById(docDataId, docFormat) {
  return new Promise((resolve, reject) => {
    GetAccessToken().then((token) => {
      let retrieveData = {
        documentDataId: docDataId,
        documentFormat: docFormat,
        context: {
          runAsUser: process.env.REACT_APP_API_USER_ID,
        },
      };
      axios
        .post(process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_VERSION + '/' + routes.docbyid, retrieveData, {
          headers: { Authorization: "Bearer " + token.access_token },
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  });
}

export async function GetAccessToken() {
  var tokenEndpoint = await axios
    .get(process.env.REACT_APP_IDENTITY_SERVER_URL + ".well-known/openid-configuration")
    .then((res) => {
      var endpoint = res.data.token_endpoint;
      return endpoint;
    })
    .catch((err) => {
      console.log("Error fetching data from identity server." + err);
      return err;
    });

  var accessToken = await axios
    .post(tokenEndpoint, identityServer.request, {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    })
    .then((res) => {
      var token = res.data;
      return token;
    })
    .catch((err) => {
      console.log("Error fetching token from identity server." + err);
      return err;
    });

  return accessToken;
}
